import TurnoverIndexPage from "../pages/analytics/turnover/TurnoverIndexPage.vue";
import ExitDeclarationStatusesIndexPage from "../pages/analytics/exitDeclarationStatuses/ExitDeclarationStatusesIndexPage.vue";
import i18n from '../i18n';

const basePath = "/app/projects/:projectUuid/analytics";

const analyticsRoutes = [
    {
        path: `${basePath}/turnover`,
        name: "TurnoverIndexPage",
        component: TurnoverIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.TurnoverIndexPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/exit-declaration-statuses`,
        name: "ExitDeclarationStatusesIndexPage",
        component: ExitDeclarationStatusesIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.ExitDeclarationStatusesIndexPage") }
                ]
            }
        }
    }
]

export default analyticsRoutes;
